import { ReactNode } from 'react';

interface Props {
  expression: boolean;
  then: () => ReactNode;
  else?: () => ReactNode;
}

export const Condition = ({ expression, then: thenExpr, else: elseExpr }: Props) => {
  if (expression) return thenExpr();
  return elseExpr?.() ?? null;
};
